/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AuthFastLaneEndpointRequest,
    AuthFastLaneEndpointRequestFromJSON,
    AuthFastLaneEndpointRequestToJSON,
    AuthFastLaneEndpointResponse,
    AuthFastLaneEndpointResponseFromJSON,
    AuthFastLaneEndpointResponseToJSON,
    BootstrapData,
    BootstrapDataFromJSON,
    BootstrapDataToJSON,
    ClientSidePathEndpointRequest,
    ClientSidePathEndpointRequestFromJSON,
    ClientSidePathEndpointRequestToJSON,
    ClientSidePathEndpointResponse,
    ClientSidePathEndpointResponseFromJSON,
    ClientSidePathEndpointResponseToJSON,
    HelpEndpointResponse,
    HelpEndpointResponseFromJSON,
    HelpEndpointResponseToJSON,
    InstallLicenseEndpointRequest,
    InstallLicenseEndpointRequestFromJSON,
    InstallLicenseEndpointRequestToJSON,
    LocaleEndpointResponse,
    LocaleEndpointResponseFromJSON,
    LocaleEndpointResponseToJSON,
    LocateEndpointRequest,
    LocateEndpointRequestFromJSON,
    LocateEndpointRequestToJSON,
    LocateProxiesEndpointRequest,
    LocateProxiesEndpointRequestFromJSON,
    LocateProxiesEndpointRequestToJSON,
    LocateProxiesEndpointResponse,
    LocateProxiesEndpointResponseFromJSON,
    LocateProxiesEndpointResponseToJSON,
    LocateResult,
    LocateResultFromJSON,
    LocateResultToJSON,
    ProxyFSSizeEndpointResponse,
    ProxyFSSizeEndpointResponseFromJSON,
    ProxyFSSizeEndpointResponseToJSON,
} from '../models';

export interface ExportNonProxiedAssetsRequest {
    rootId: string;
}

export interface ExportNonProxiedAssetsForPathRequest {
    path: string;
    rootId: string;
}

export interface ExportUpdatesRequest {
    rootId: string;
}

export interface FastLaneLoginPageRequest {
    token: string;
}

export interface FastLaneLoginWithPasswordRequest {
    token: string;
    authFastLaneEndpointRequest: AuthFastLaneEndpointRequest;
}

export interface GetClientSideURLRequest {
    clientSidePathEndpointRequest: ClientSidePathEndpointRequest;
}

export interface GetHelpPageRequest {
    id: string;
}

export interface GetLocaleRequest {
    lang: string;
}

export interface GetStoredImageRequest {
    name: string;
}

export interface InstallLicenseRequest {
    installLicenseEndpointRequest: InstallLicenseEndpointRequest;
}

export interface LanguageServerRequestRequest {
    language: string;
}

export interface LocateFileRequest {
    locateEndpointRequest: LocateEndpointRequest;
}

export interface LocateProxiesRequest {
    locateProxiesEndpointRequest: LocateProxiesEndpointRequest;
    forRoot?: number;
    includeProxies?: boolean;
}

/**
 * 
 */
export class PrivateApi extends runtime.BaseAPI {

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportNonProxiedAssetsRaw(requestParameters: ExportNonProxiedAssetsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.rootId === null || requestParameters.rootId === undefined) {
            throw new runtime.RequiredError('rootId','Required parameter requestParameters.rootId was null or undefined when calling exportNonProxiedAssets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/export/non-proxied/{root_id}`.replace(`{${"root_id"}}`, encodeURIComponent(String(requestParameters.rootId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportNonProxiedAssets(requestParameters: ExportNonProxiedAssetsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.exportNonProxiedAssetsRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportNonProxiedAssetsForPathRaw(requestParameters: ExportNonProxiedAssetsForPathRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path','Required parameter requestParameters.path was null or undefined when calling exportNonProxiedAssetsForPath.');
        }

        if (requestParameters.rootId === null || requestParameters.rootId === undefined) {
            throw new runtime.RequiredError('rootId','Required parameter requestParameters.rootId was null or undefined when calling exportNonProxiedAssetsForPath.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/export/non-proxied/{root_id}/{path}`.replace(`{${"path"}}`, encodeURIComponent(String(requestParameters.path))).replace(`{${"root_id"}}`, encodeURIComponent(String(requestParameters.rootId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportNonProxiedAssetsForPath(requestParameters: ExportNonProxiedAssetsForPathRequest, initOverrides?: RequestInit): Promise<void> {
        await this.exportNonProxiedAssetsForPathRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportUpdatesRaw(requestParameters: ExportUpdatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.rootId === null || requestParameters.rootId === undefined) {
            throw new runtime.RequiredError('rootId','Required parameter requestParameters.rootId was null or undefined when calling exportUpdates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/export/updates/{root_id}`.replace(`{${"root_id"}}`, encodeURIComponent(String(requestParameters.rootId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async exportUpdates(requestParameters: ExportUpdatesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.exportUpdatesRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async fastLaneLoginPageRaw(requestParameters: FastLaneLoginPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AuthFastLaneEndpointResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling fastLaneLoginPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/fast-lane/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthFastLaneEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async fastLaneLoginPage(requestParameters: FastLaneLoginPageRequest, initOverrides?: RequestInit): Promise<AuthFastLaneEndpointResponse> {
        const response = await this.fastLaneLoginPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async fastLaneLoginWithPasswordRaw(requestParameters: FastLaneLoginWithPasswordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AuthFastLaneEndpointResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling fastLaneLoginWithPassword.');
        }

        if (requestParameters.authFastLaneEndpointRequest === null || requestParameters.authFastLaneEndpointRequest === undefined) {
            throw new runtime.RequiredError('authFastLaneEndpointRequest','Required parameter requestParameters.authFastLaneEndpointRequest was null or undefined when calling fastLaneLoginWithPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/auth/fast-lane/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthFastLaneEndpointRequestToJSON(requestParameters.authFastLaneEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthFastLaneEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async fastLaneLoginWithPassword(requestParameters: FastLaneLoginWithPasswordRequest, initOverrides?: RequestInit): Promise<AuthFastLaneEndpointResponse> {
        const response = await this.fastLaneLoginWithPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async getRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<BootstrapData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/bootstrap`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BootstrapDataFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async get(initOverrides?: RequestInit): Promise<BootstrapData> {
        const response = await this.getRaw(initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `client:access` 
     */
    async getClientSideURLRaw(requestParameters: GetClientSideURLRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClientSidePathEndpointResponse>> {
        if (requestParameters.clientSidePathEndpointRequest === null || requestParameters.clientSidePathEndpointRequest === undefined) {
            throw new runtime.RequiredError('clientSidePathEndpointRequest','Required parameter requestParameters.clientSidePathEndpointRequest was null or undefined when calling getClientSideURL.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/client-side-url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientSidePathEndpointRequestToJSON(requestParameters.clientSidePathEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientSidePathEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `client:access` 
     */
    async getClientSideURL(requestParameters: GetClientSideURLRequest, initOverrides?: RequestInit): Promise<ClientSidePathEndpointResponse> {
        const response = await this.getClientSideURLRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getHelpPageRaw(requestParameters: GetHelpPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HelpEndpointResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getHelpPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/help/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getHelpPage(requestParameters: GetHelpPageRequest, initOverrides?: RequestInit): Promise<HelpEndpointResponse> {
        const response = await this.getHelpPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async getLocaleRaw(requestParameters: GetLocaleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LocaleEndpointResponse>> {
        if (requestParameters.lang === null || requestParameters.lang === undefined) {
            throw new runtime.RequiredError('lang','Required parameter requestParameters.lang was null or undefined when calling getLocale.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/locale/{lang}`.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters.lang))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LocaleEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async getLocale(requestParameters: GetLocaleRequest, initOverrides?: RequestInit): Promise<LocaleEndpointResponse> {
        const response = await this.getLocaleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async getProxyFSSizeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProxyFSSizeEndpointResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/media/proxyfs-size`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProxyFSSizeEndpointResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async getProxyFSSize(initOverrides?: RequestInit): Promise<ProxyFSSizeEndpointResponse> {
        const response = await this.getProxyFSSizeRaw(initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `media:access` (read) / `media:roots:manage` (write) 
     */
    async getStoredImageRaw(requestParameters: GetStoredImageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getStoredImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/image/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `media:access` (read) / `media:roots:manage` (write) 
     */
    async getStoredImage(requestParameters: GetStoredImageRequest, initOverrides?: RequestInit): Promise<void> {
        await this.getStoredImageRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `system:admin-access` 
     */
    async installLicenseRaw(requestParameters: InstallLicenseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installLicenseEndpointRequest === null || requestParameters.installLicenseEndpointRequest === undefined) {
            throw new runtime.RequiredError('installLicenseEndpointRequest','Required parameter requestParameters.installLicenseEndpointRequest was null or undefined when calling installLicense.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/license/install`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstallLicenseEndpointRequestToJSON(requestParameters.installLicenseEndpointRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `system:admin-access` 
     */
    async installLicense(requestParameters: InstallLicenseRequest, initOverrides?: RequestInit): Promise<void> {
        await this.installLicenseRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `system:admin-access` 
     */
    async languageServerRequestRaw(requestParameters: LanguageServerRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: object | undefined; }>> {
        if (requestParameters.language === null || requestParameters.language === undefined) {
            throw new runtime.RequiredError('language','Required parameter requestParameters.language was null or undefined when calling languageServerRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/language-server/{language}`.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters.language))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * ### Required permissions    * User account permission: `system:admin-access` 
     */
    async languageServerRequest(requestParameters: LanguageServerRequestRequest, initOverrides?: RequestInit): Promise<{ [key: string]: object | undefined; }> {
        const response = await this.languageServerRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async locateFileRaw(requestParameters: LocateFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LocateResult>> {
        if (requestParameters.locateEndpointRequest === null || requestParameters.locateEndpointRequest === undefined) {
            throw new runtime.RequiredError('locateEndpointRequest','Required parameter requestParameters.locateEndpointRequest was null or undefined when calling locateFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/locate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocateEndpointRequestToJSON(requestParameters.locateEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LocateResultFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async locateFile(requestParameters: LocateFileRequest, initOverrides?: RequestInit): Promise<LocateResult> {
        const response = await this.locateFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async locateProxiesRaw(requestParameters: LocateProxiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<LocateProxiesEndpointResponse>>> {
        if (requestParameters.locateProxiesEndpointRequest === null || requestParameters.locateProxiesEndpointRequest === undefined) {
            throw new runtime.RequiredError('locateProxiesEndpointRequest','Required parameter requestParameters.locateProxiesEndpointRequest was null or undefined when calling locateProxies.');
        }

        const queryParameters: any = {};

        if (requestParameters.forRoot !== undefined) {
            queryParameters['for_root'] = requestParameters.forRoot;
        }

        if (requestParameters.includeProxies !== undefined) {
            queryParameters['include_proxies'] = requestParameters.includeProxies;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/panel/locate-proxies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocateProxiesEndpointRequestToJSON(requestParameters.locateProxiesEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LocateProxiesEndpointResponseFromJSON));
    }

    /**
     * ### Required permissions    * User account permission: `media:access` 
     */
    async locateProxies(requestParameters: LocateProxiesRequest, initOverrides?: RequestInit): Promise<Array<LocateProxiesEndpointResponse>> {
        const response = await this.locateProxiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * localhost only 
     */
    async submitNodeStatusRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/node-stats`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * localhost only 
     */
    async submitNodeStatus(initOverrides?: RequestInit): Promise<void> {
        await this.submitNodeStatusRaw(initOverrides);
    }

}
